import { Button } from "@material-ui/core";
import React, { useState } from "react";
import ConfirmationModal from "../../../../Shared/ConfimationModal";

function DeleteApiBtn({ apiKey, handleAPIKeyDelete, classes, parentIndex }) {
  const [removeAPIKeyIsOpen, setRemoveAPIKeyIsOpen] = useState({
    open: false,
    content: "",
  });
  return (
    <span>
      <Button
        size="small"
        variant="contained"
        className={classes.delUserBtn}
        name={parentIndex}
        data-testid={`delete_api_key_${apiKey.api_key}`}
        onClick={() => {
          setRemoveAPIKeyIsOpen({
            open: true,
            content: "Are you sure you want to delete this API key?",
          });
        }}
      >
        DELETE KEY
      </Button>
      {removeAPIKeyIsOpen.open && (
        <ConfirmationModal
          open={removeAPIKeyIsOpen.open}
          content={removeAPIKeyIsOpen.content}
          // item={isOpen.item}
          deleteHandler={() => {
            handleAPIKeyDelete(apiKey, parentIndex);
          }}
          setIsopen={setRemoveAPIKeyIsOpen}
        />
      )}
    </span>
  );
}

export default DeleteApiBtn;
